export interface IWarranty  {
    warranty_id: number;
    warranty_firstname: string;
    warranty_lastname: string;
    warranty_address: string;
    warranty_address1: string;
    warranty_suburb: string;
    warranty_state: string;
    warranty_postcode : number;
    warranty_contact_number : string;
    warranty_email : string;
    warranty_category : string;
    warranty_sku : string;
    warranty_barcode : string;
    warranty_website : string;
    warranty_subscrib : number;
    warranty_purchased_date : Date 
    warranty_purchased_dateDisplay : string 
    warranty_createdAt : Date;
    warranty_createdAtDisplay : string;
    warranty_subscribe : string;
    warranty_register_site : string;
    isSelected : boolean;
    warranty_new_warranty_period: number,
    warranty_warranty_end_date: Date,
    warranty_warranty_end_dateDisplay: string,
    warranty_order_no: string
}


export interface IWarrantyResponse {
    code: number;
    message: string;
    data: IWarranty[];
    
}


export interface IWarrantySearchFormValues extends Partial<IWarranty> {
    time?: Date;
  }
  
  export class WarrantySearchFormValues implements IWarrantySearchFormValues {
    brand: string = 'Devanti';
    firstName: string = '';
    lastName: string = '';
    contactNumber : string = '';
    registrationDateFrom?: Date = undefined;
    registrationDateTo?: Date = undefined;
    sku: string = '';
    time?: Date = undefined;
  }